/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import _, { isEmpty, parseInt, get } from "lodash"
import root from "window-or-global"
import {
  Select, Button, Input, Switch, Modal, Spin, Checkbox,
} from "antd"
import Loader from "../../../common/UI/Loader"
import PlusSign from "./PlusOutlined.svg"
import AddDocumentModal from "../common/AddDocumentModal"
import { fetchComplianceTeamsAPI } from "../../../../container/AI/api"
import container from "../../../../container/BrokerDashboard/editAgentContainer"

const Wrap = styled.div`
  margin: 20px;
`
const Title = styled.h1`
  margin-top: 34px;
  margin-left: 17px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  ${props => props.body && `
  margin-top: 0px;
  padding-left: 46px;
`}
`
const Content = styled.div`
  margin-top: 58px;
  margin-left: 17px;
  max-width: 1400px;
  height: 100%;
  .Content::-webkit-scrollbar {
    display: none;
  };
`
const HeaderWrap = styled.div`
  padding-left: 46px;
  padding-top: 48px;
  padding-right: 28px;
  display: flex;
  justify-content: space-between;
`

const TitleWrap = styled.div`
  padding-left: 46px;
  padding-top: 48px;
  padding-right: 28px;
  display: flex;
  justify-content: flex-start;
`

const AddNewDoc = styled.div`
  display: flex;
  margin-left: 48px;
  margin-top: 18px;
  cursor: pointer;
  ${props => props.colist && `
  margin-left: 0px;
`}
`
const Image = styled.img`
  margin-right: 16px;
`
const AddNew = styled.h3`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #100063;
  margin: 0px;
`
const DropdownDiv = styled.div`
  display: flex;
`
const TeamSelectWrap = styled.div`
  width: 367px;
  margin-left: 20px;
  .ant-select-selector {
    min-height: 40px;
    max-height: 96px;
    overflow-y: auto;
    align-items: center;
    padding: 6px 11px;
    border-radius: 4px;
  }
  .ant-select-selection-overflow {
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }
  .ant-select-selection-overflow-item {
    align-self: center;
  }
  .team-tag-chip {
    display: inline-flex;
    align-items: center;
    height: 26px;
    padding: 0 8px 0 10px;
    margin: 0;
    font-size: 13px;
    line-height: 22px;
    color: #100063;
    background: #e8e6f0;
    border: 1px solid #d0cce0;
    border-radius: 6px;
    max-width: 160px;
  }
  .team-tag-chip .team-tag-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }
  .team-tag-more {
    display: inline-flex;
    align-items: center;
    height: 26px;
    padding: 0 10px;
    font-size: 13px;
    color: #595959;
    background: #f5f5f5;
    border-radius: 6px;
    border: 1px solid #e8e8e8;
  }
`
const TeamDropdownOptions = styled.div`
  min-width: 320px;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px 0;
  .team-option-row {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
      background: #f5f5f5;
    }
    .ant-checkbox-wrapper {
      margin-right: 10px;
    }
  }
`
const Subtitle = styled.h2`
  margin: 0px;
  margin-top: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  ${props => props.body && `
  margin-top: 0px;
  padding-left: 63px;
  font-size: 16px;
`}
`
const SubHeading = styled.h2`
  margin: 0px;
  margin-top: 8px;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
`
const HR = styled.div`
  width: 100%;
  height: 0px;
  border: 1px solid #E6E6E6;
  margin-top: 32px;
  margin-left: 40px;
  ${props => props.colist && `
  margin-left: -9px;
  `}
  ${props => props.last && `
  margin-left: -9px;
  margin-bottom: 30px;
  `}
`
const Body = styled.div`
  // scroll: scroll;
  // overflow-x: hidden;
  height: 1000px;
  &::-webkit-scrollbar {
    display: none;
  }
`
const TitleDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`
const InfoDiv = styled.div`
  width: 100%;
  min-height: 102px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  margin-top: 87px;
  margin-left: 50px;
  margin-right: 50px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding: 16px 20px;
  box-sizing: border-box;
  ${props => props.body && `
  margin-top: 23px;
  margin-bottom: 44px;
`}
${props => props.stuck && `
  margin-top: 0px;
  margin-bottom: 44px;
  margin-left: 0px;
`}
${props => props.first && `
  margin-top: 0px;
  margin-bottom: 44px;
`}
${props => props.owner && `
  padding-left: 16px;
  margin-left: 50px;
  margin-top: 23px;
`}
`
const Section = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  max-width: 320px;
`
const SectionTemplateId = styled(Section)`
  max-width: 420px;
  min-width: 320px;
`
const SmallTitle = styled.h3`
  font-size: 14px;
  font-weight: 200;
  margin-top: 8px;
`
const AdditionDocuments = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 86px;
`
const Divider = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 35px;
`
const SmallHR = styled.div`
  width: 400.5px;
  height: 0px;
  border: 1px solid #E6E6E6;
  margin-top: 32px;
  margin-left: 40px;
`
const SmallText = styled.h3`
  width: 158px;
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding: 0px;
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
`
const MLSDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 250px;
  ${props => props.body && `
  padding-left: 0px;
  `}
  ${props => props.contingency && `
    padding-left: 0px;
    width: 800px;
  `}
`
const Text = styled.p`
  margin: 0px;
  width: 553px;
  padding-left: 63px;
  margin-top: 20px;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  ${props => props.colist && `
  font-weight: 100;
  color: #8A8A8A;
  padding-left: 0;
  `}
  ${props => props.key && `
  font-weight: 100;
  padding-left: 0;
  `}
`
const InvalidText = styled.h3`
  margin-top: 5px;
  margin-bottom: 0px;
  color: red;
  font-size: 12px;
`

const TitleAndTemplate = ({
  isEdit,
  valueName,
  valueTemplate,
  valueTeamId,
  entityName,
  entityType,
  state,
  teamName,
  teamsList,
  templateList,
  setTemplateList,
  index,
  templateData,
  setTemplateInvalid,
  deleteTemplates,
  localTemplateData,
  setLocalTemplateData,
}) => {
  const [name, setName] = useState("")
  const [template, setTemplate] = useState("")
  const [selectedTeamId, setSelectedTeamId] = useState(valueTeamId)
  const [isInvalidMessage, setIsInvalidMessage] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [invalidArray, setInvalidArray] = useState([])

  useEffect(() => {
    setSelectedTeamId(valueTeamId)
  }, [valueTeamId])

  useEffect(() => {
    setName(valueName)
  }, [valueName])

  useEffect(() => {
    setTemplate(valueTemplate)
  }, [valueTemplate])

  const handleAddTemplate = (nameTarget, templateTarget, teamIdVal) => {
    if (!isEmpty(templateList)) {
      templateList.map((x) => {
        if (x.idToAdd === index) {
          if (index.includes("old-temp")) {
            const id = parseInt((index.split("-").pop()), 10)
            x.name = nameTarget || ""
            x.id = id
            x.idToAdd = index
            x.templateId = templateTarget || ""
            x.isEdited = true
            x.entityName = entityName
            x.entityType = entityType
            x.state = state
            if (teamIdVal !== undefined) x.team_id = teamIdVal
          } else {
            x.name = nameTarget || ""
            x.idToAdd = index
            x.templateId = templateTarget || ""
            x.entityName = entityName
            x.entityType = entityType
            x.state = state
            if (teamIdVal !== undefined) x.team_id = teamIdVal
          }
        }
      })
    }
  }

  const handleTeamChange = (newTeamId) => {
    const value = newTeamId && newTeamId !== "__all__" ? newTeamId : undefined
    setSelectedTeamId(value)
    if (!isEmpty(templateList)) {
      const next = templateList.map(x => (
        x.idToAdd === index
          ? {
            ...x,
            team_id: value,
            isEdited: index.includes("old-temp") ? true : x.isEdited,
          }
          : x
      ))
      setTemplateList(next)
    }
  }

  const handleDelete = (indexLocal) => {
    const checkId = indexLocal.split("-").pop()
    if (indexLocal.includes("old")) {
      templateData.map((x) => {
        if (x.id.toString() === checkId) {
          deleteTemplates.push(x.id)
          localTemplateData.splice(localTemplateData.indexOf(x), 1)
          setLocalTemplateData([...localTemplateData])
        }
      })
    }
    // setTemplateList([...templateList.filter(x => x.idToAdd !== indexLocal)])
    templateList.map((x) => {
      if (x.idToAdd === indexLocal) {
        templateList.splice(templateList.indexOf(x), 1)
      }
    })

    const checkIdInTemplateDataIndex = templateData.findIndex(x => x.id.toString() === checkId)

    if (checkIdInTemplateDataIndex !== -1) {
      templateData.map((x) => {
        if (x.id.toString() !== checkId) {
          setTemplateInvalid(false)
        }
      })
    } else {
      setTemplateInvalid(false)
    }

    setDeleteModal(false)
  }

  //Function to keep save button disabled if even one template ID is duplicate
  const checkDisabled = () => {
    if (templateList.length > 1) {
      setInvalidArray([])
      templateList.map((x) => {
        templateList.map((y) => {
          if (x.templateId === y.templateId && x.idToAdd !== y.idToAdd) {
            invalidArray.push(y)
          }
          // if (x.templateId === y.templateId && x.idToAdd !== y.idToAdd && x.state === y.state) {
          //   invalidArray.push(y)
          // }
        })
      })
      if (invalidArray.length > 0) {
        setTemplateInvalid(true)
      } else {
        setTemplateInvalid(false)
      }
    }
  }


  const checkIsDeleted = (indexLocal) => {
    const checkId = indexLocal.split("-").pop()
    deleteTemplates.map((x) => {
      if (x.toString() === checkId) {
        return true
      }
      return false
    })
  }

  const handleCancel = () => {
    setDeleteModal(false)
  }

  return (
    <>
      <InfoDiv
        owner
      >
        <Section>
          <SmallTitle>Title</SmallTitle>
          <Input
            placeholder="Enter the Document Name"
            disabled={!isEdit}
            style={{
              width: "100%",
              maxWidth: 280,
              height: 32,
              background: "#F9F8FF",
              border: 1,
              borderColor: "#D9D9D9",
              borderRadius: 2,
              color: "black",
            }}
            value={name}
            onChange={(e) => {
              setName(e.target.value)
              handleAddTemplate(e.target.value, template, undefined)
            }}
          />
        </Section>
        <Modal
          title="Delete Template"
          visible={deleteModal}
          onOk={() => handleDelete(index)}
          onCancel={handleCancel}
        >
            Are you sure you want to delete this template?
        </Modal>
        <SectionTemplateId>
          <SmallTitle>Template ID</SmallTitle>
          <Input
            placeholder="Enter the Template ID"
            disabled={!isEdit}
            required
            style={{
              width: "100%",
              maxWidth: 400,
              minWidth: 280,
              height: 32,
              background: "#F9F8FF",
              borderThickness: 1,
              borderColor: "#D9D9D9",
              borderRadius: 2,
              color: "black",
            }}
            value={template}
            onChange={(e) => {
              setTemplate(e.target.value)
              handleAddTemplate(name, e.target.value, undefined)
            }}
          />
          {isInvalidMessage === true ? (
            <InvalidText>* The Template ID is duplicate, please enter a different Template ID</InvalidText>
          ) : null}
        </SectionTemplateId>
        <Section>
          <SmallTitle>Team</SmallTitle>
          {isEdit ? (
            <Select
              placeholder="Select team"
              allowClear
              style={{ width: "100%", height: 32, maxWidth: 280 }}
              value={selectedTeamId && selectedTeamId !== "__all__" ? selectedTeamId : undefined}
              onChange={val => handleTeamChange(val)}
              options={(teamsList || []).map(t => ({ label: t.team_name, value: t.team_id }))}
            />
          ) : (
            <SmallText>{teamName || "-"}</SmallText>
          )}
        </Section>
        {isEdit ? (
            <>
              {checkIsDeleted === true ? (
                <Button
                  type="primary"
                  style={{
                    alignSelf: "center",
                  }}
                  disabled
                >
                  Deleted
                </Button>
              ) : (
                <Button
                  style={{
                    alignSelf: "center",
                  }}
                  disabled={!(index.includes("old"))}
                  onClick={() => setDeleteModal(true)}
                >
                  Delete
                </Button>
              )}
            </>
        ) : null}
      </InfoDiv>
    </>
  )
}

const TC_STATE = [
  { label: "California", value: "california" },
  { label: "Colorado", value: "colorado" },
  { label: "Texas", value: "texas" },
  { label: "Florida", value: "florida" },
  { label: "Washington", value: "washington" },
  { label: "Georgia", value: "georgia" },
  { label: "Oregon", value: "oregon" },
  { label: "Arizona", value: "arizona" },
  { label: "New York", value: "newyork" },
  { label:"Tennessee", value: "tennessee"},
  { label: "All State", value: "All State" },
]

const ViewPage = ({
  getOffersDocusignTemplate,
  getDocusignTemplateResponse,
  getOffersTotalCommonTemplate,
  getTotalCountTemplateResponse,
  templateList,
  setTemplateInvalid,
  templateInvalid,
  setTemplateList,
  createOffersDocusignTemplate,
  deleteTemplates,
  setDeleteTemplates,
  deleteOffersDocusignTemplate,
}) => {
  const [isEdit, setIsEdit] = useState(false)

  const [addNewOG, setAddNewOG] = useState(false)

  const [addOGDoc, setAddOGDoc] = useState([1])
  const [state, setState] = useState("california")
  const [newYorkSubType, setNewYorkSubType] = useState()

  const [localTemplateData, setLocalTemplateData] = useState([])
  const [localList, setLocalList] = useState([])

  const [saveModal, setSaveModal] = useState(false)
  const [showSpin, setShowSpin] = useState(false)
  const [addDocumentModalVisible, setAddDocumentModalVisible] = useState(false)
  const [teamsList, setTeamsList] = useState([])
  const [selectedTeamIds, setSelectedTeamIds] = useState([])

  const {
    data: templateData,
    isFetching,
  } = getDocusignTemplateResponse || {}

  const {
    data: result,
  } = getTotalCountTemplateResponse || {}

  // Helper to get original state name from normalized value for API calls
  const getOriginalStateName = (normalizedState) => {
    const stateMap = {
      'california': 'California',
      'newyork': 'New York',
      'texas': 'Texas',
      'florida': 'Florida',
      'washington': 'Washington',
      'oregon': 'Oregon',
      'colorado': 'Colorado',
      'arizona': 'Arizona',
      'georgia': 'Georgia',
      'northcarolina': 'North Carolina',
      'southcarolina': 'South Carolina',
    }
    return stateMap[normalizedState] || normalizedState.charAt(0).toUpperCase() + normalizedState.slice(1)
  }

  useEffect(() => {
    getOffersTotalCommonTemplate()
  }, [])

  useEffect(() => {
    fetchComplianceTeamsAPI()
      .then(res => {
        const data = res.data?.response?.data || res.data?.response || []
        setTeamsList(Array.isArray(data) ? data : [])
      })
      .catch(() => setTeamsList([]))
  }, [])

  // Fetch templates when state, subtype or team filter changes
  useEffect(() => {
    const originalState = getOriginalStateName(state)
    const teamIdsParam = selectedTeamIds && selectedTeamIds.length > 0 ? selectedTeamIds : undefined
    getOffersDocusignTemplate({ state: originalState, nySubType: newYorkSubType, teamIds: teamIdsParam })
  }, [state, newYorkSubType, selectedTeamIds])

  useEffect(() => {
    if (templateData) {
      templateData.map((x) => {
        templateList.push({
          idToAdd: `old-temp-${x.id}`,
          name: x.name,
          templateId: x.template_id,
          entityName: x.entity_name,
          entityType: x.entity_type,
          state: x.state,
          team_id: x.team_id,
          isEdited: false,
        })
      })
      setLocalTemplateData(templateData)
    }
  }, [templateData])

  useEffect(() => {
    if (state === "newyork") {
      setNewYorkSubType("one_key_mls")
    } else {
      setNewYorkSubType(undefined)
    }
  }, [state])

  const addOGDocFunc = () => {
    setAddOGDoc([...addOGDoc, addOGDoc.length])
  }


const getTotalCountByState = (givenState) => {
  const res = _.find(result, {'state': givenState})
  return res ? res.total : 0
}

  const shouldShowTemplate = (template) => {
    const normalizeState = (s) => s ? s.toLowerCase().replace(/\s+/g, '') : ''
    const normalizedTemplateState = normalizeState(template.state)
    const normalizedSelectedState = normalizeState(state)
    const stateMatches = normalizedTemplateState === normalizedSelectedState
    if (!newYorkSubType) {
      if (!stateMatches) return false
    } else {
      const subtypeMatches = template.ny_sub_type === newYorkSubType || template.sub_type === newYorkSubType
      if (!(stateMatches && subtypeMatches)) return false
    }
    // When a team is selected we pass teamId to the API, so results are already filtered - show all returned
    return true
  }

  const getTeamNameById = (teamId) => {
    if (teamId == null || teamId === undefined) return null
    const team = teamsList.find(t => Number(t.team_id) === Number(teamId))
    return team ? team.team_name : null
  }

  const saveCancel = () => {
    setSaveModal(false)
  }

  const checkIfEmpty = () => {
    let isInvalid = null
    if (!isEmpty(templateList)) {
      templateList.find((x) => {
        if ((x.name === "") || (x.templateId === "")) {
          isInvalid = window.confirm("Some values are empty, please fill appropriate details in the empty fields")
          if (isInvalid) {
            setSaveModal(false)
          }
        }
      })
    }
    return isInvalid
  }

  const saveList = () => {
    console.log("newYorkSubType", newYorkSubType)
    const checking = checkIfEmpty() === true || false
    // return
    if (checking === true) {
      setIsEdit(true)
      return
    }
    if (checking === false) {
      if (!isEmpty(templateList)) {
        templateList.forEach((x) => {
          if (x.name !== "" && x.templateId !== "") {
            if (x.isEdited && x.isEdited === true) {
              const { team_id, ...rest } = x
              const templateToAdd = { ...rest }
              if (state === "newyork") {
                templateToAdd.state = "New York"
                templateToAdd.nySubType = newYorkSubType
              }
              if (team_id != null) templateToAdd.teamId = team_id
              localList.push(templateToAdd)
            } else if (!("isEdited" in x)) {
              const { team_id, ...rest } = x
              const templateToAdd = { ...rest }
              if (state === "newyork") {
                templateToAdd.state = "New York"
                templateToAdd.nySubType = newYorkSubType
              }
              if (team_id != null) templateToAdd.teamId = team_id
              localList.push(templateToAdd)
            }
          }
        })
        if (!isEmpty(localList)) {
          createOffersDocusignTemplate({
            payload: localList,
            callback: () => {
              setShowSpin(false)
              root.location.reload()
            },
          })
          setShowSpin(true)
        }
      }
      if (!isEmpty(deleteTemplates)) {
        deleteTemplates.map((id) => {
          deleteOffersDocusignTemplate({
            id,
            callback: () => {
              setShowSpin(false)
              root.location.reload()
            },
          })
        })
        setShowSpin(true)
      }
      if (isEmpty(deleteTemplates) && isEmpty(localList)) {
        root.location.reload()
      }
      setTemplateList([])
      setLocalList([])
      setIsEdit(false)
      setSaveModal(false)
    }
  }

  return (
    <Wrap>
      <TitleWrap>
        <Title body>Document Library</Title>
      </TitleWrap>
      {showSpin === true ? (
        <Spin
          size="large"
          style={{
            alignSelf: "center",
            marginLeft: "25%",
            marginTop: "25%",
          }}
        />
      ) : (
        <Content>
          <Modal
            title="Save Changes"
            visible={saveModal}
            onOk={saveList}
            onCancel={saveCancel}
          >
            Are you sure you want to save these changes?
          </Modal>
          <AddDocumentModal
            visible={addDocumentModalVisible}
            onClose={() => setAddDocumentModalVisible(false)}
            onSave={(payload, modalCallback) => {
              setShowSpin(true)
              createOffersDocusignTemplate({
                payload: [payload],
                callback: () => {
                  setShowSpin(false)
                  if (modalCallback) modalCallback()
                  root.location.reload()
                },
              })
            }}
            defaultState={state}
          />
          <HeaderWrap>
          <DropdownDiv>
              <Subtitle>Saved Offer Templates  </Subtitle>
              {result && <SubHeading>  ( Total - {getTotalCountByState(state)} )</SubHeading> }
            </DropdownDiv>
          </HeaderWrap>
          <HeaderWrap>
            <DropdownDiv>
              <Subtitle>State</Subtitle>
              <Select
                defaultValue="California"
                style={{
                  width: 367,
                  marginLeft: 20,
                  marginTop: 0,
                }}
                disabled={isEdit}
                onChange={(value) => {
                  setState(value)
                }}
                options={TC_STATE}
              />
            </DropdownDiv>
            {state === "newyork" && (
              <DropdownDiv>
                <Subtitle>Sub Type</Subtitle>
                <Select
                  value={newYorkSubType}
                  style={{
                    width: 367,
                    marginLeft: 20,
                    marginTop: 0,
                  }}
                  disabled={isEdit}
                  onChange={(value) => {
                    setNewYorkSubType(value)
                  }}
                  options={[
                    {
                      value: "one_key_mls",
                      label: "One key MLS",
                    },
                    {
                      value: "brooklyn_mls",
                      label: "Brooklyn MLS",
                    },
                    {
                      value: "rls",
                      label: "RLS",
                    },
                    {
                      value: "other",
                      label: "Other",
                    }
                  ]}
                />
              </DropdownDiv>
            )}
            <DropdownDiv>
              <Subtitle>Team</Subtitle>
              <TeamSelectWrap>
                <Select
                  mode="multiple"
                  placeholder="All Teams"
                  allowClear
                  maxTagCount={1}
                  maxTagPlaceholder={(omittedValues) => (
                    <span className="team-tag-more">+{omittedValues.length} more</span>
                  )}
                  tagRender={(props) => {
                    const { label, closable, onClose } = props
                    return (
                      <span className="team-tag-chip">
                        <span className="team-tag-label">{label}</span>
                        {closable && (
                          <span
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onClose() }}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClose() }}
                            style={{ marginLeft: 6, cursor: "pointer", opacity: 0.7 }}
                            aria-label="Remove"
                          >
                            ×
                          </span>
                        )}
                      </span>
                    )
                  }}
                  style={{
                    width: "100%",
                    marginTop: 0,
                  }}
                  disabled={isEdit}
                  value={selectedTeamIds}
                  onChange={value => setSelectedTeamIds(Array.isArray(value) ? value : [])}
                  options={teamsList.map(t => ({ label: t.team_name, value: t.team_id }))}
                  dropdownRender={() => (
                    <TeamDropdownOptions>
                      {teamsList.map(t => (
                        <div
                          key={t.team_id}
                          className="team-option-row"
                          role="option"
                          aria-selected={selectedTeamIds.includes(t.team_id)}
                          onClick={() => {
                            const next = selectedTeamIds.includes(t.team_id)
                              ? selectedTeamIds.filter(id => id !== t.team_id)
                              : [...selectedTeamIds, t.team_id]
                            setSelectedTeamIds(next)
                          }}
                        >
                          <Checkbox checked={selectedTeamIds.includes(t.team_id)} />
                          <span>{t.team_name}</span>
                        </div>
                      ))}
                    </TeamDropdownOptions>
                  )}
                />
              </TeamSelectWrap>
            </DropdownDiv>
            <div style={{ display: "flex", gap: 12 }}>
              <Button
                style={{
                  width: 170,
                  background: "#100063",
                  color: "white",
                }}
                onClick={() => setAddDocumentModalVisible(true)}
              >
                Add Document
              </Button>
              {isEdit === false ? (
                <Button
                  style={{
                    width: 170,
                    background: "#100063",
                    color: "white",
                  }}
                  onClick={() => {
                    setIsEdit(true)
                  }}
                >
                  Edit
                </Button>
              ) : (
                <>
                  <Button
                    style={{
                      width: 170,
                      background: "#24AE60",
                      color: "white",
                    }}
                    disabled={templateInvalid}
                    onClick={() => {
                      setSaveModal(true)
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    style={{
                      width: 170,
                      background: "red",
                      color: "white",
                    }}
                    disabled={templateInvalid}
                    onClick={() => {
                      setIsEdit(false)
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </HeaderWrap>
          <HR />
          <Body>
            {isFetching === true ? (
              <Loader />
            ) : (
              <>
                {localTemplateData && !isEmpty(localTemplateData) ? localTemplateData.map(x => (
                  <>
                    {x.entity_type.includes("common_entity_type") && x.entity_name === "common_entity_name" ? (
                      <>
                        {shouldShowTemplate(x) ? (
                          <TitleAndTemplate
                            index={`old-temp-${x.id}`}
                            deleteTemplates={deleteTemplates}
                            setDeleteTemplates={setDeleteTemplates}
                            templateData={templateData}
                            localTemplateData={localTemplateData}
                            setLocalTemplateData={setLocalTemplateData}
                            isShifted={false}
                            state={state}
                            entityName="common_entity_name"
                            entityType="common_entity_type"
                            teamName={getTeamNameById(x.team_id != null ? x.team_id : x.teamId)}
                            valueTeamId={x.team_id != null ? x.team_id : x.teamId}
                            teamsList={teamsList}
                            templateList={templateList}
                            setTemplateList={setTemplateList}
                            isEdit={isEdit}
                            addArray={addOGDoc}
                            setAddArray={setAddOGDoc}
                            valueName={x.name}
                            setTemplateInvalid={setTemplateInvalid}
                            valueTemplate={x.template_id}
                          />
                        ) : null}
                      </>
                    ) : null}
                  </>
                )) : (
                  <Text>No documents added for this category yet.</Text>
                )}
              </>
            )}
            {addNewOG === true ? (
              <>
                {addOGDoc.length && addOGDoc.map((x, i) => (
                  <>
                    {i > 0 && (
                      <TitleAndTemplate
                        key={x}
                        addArray={addOGDoc}
                        setAddArray={setAddOGDoc}
                        index={`new-temp-${i}`}
                        templateData={templateData}
                        isShifted={false}
                        state={state}
                        teamName={null}
                        valueTeamId={undefined}
                        teamsList={teamsList}
                        templateList={templateList}
                        setTemplateList={setTemplateList}
                        setTemplateInvalid={setTemplateInvalid}
                        entityName="common_entity_name"
                        entityType="common_entity_type"
                        isEdit={isEdit}
                      />
                    )}
                  </>
                ))}
              </>
            ) : null}
          </Body>
        </Content>
      )}
    </Wrap>
  )
}

export default container(ViewPage)
